/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState } from 'react'
import {
Text,
View,
Alert,
ScrollView,
SafeAreaView,
    Platform
} from 'react-native';
import styles from './styles';
import { TutorialDeviceStorage, OTAUpdates } from '../../utilities';
import { getAuth, signOut, Firestore } from '../../firebase/config';
import * as Linking from 'expo-linking';
import { Icon, ListItem, Divider, Button } from 'react-native-elements';
import { APPLICATION_VERSION, COPYRIGHT_YEAR } from "@env";


export default function SettingsScreen(props) {
const { navigation } = props;
const auth = getAuth();
const uid = auth.currentUser.uid;
const fcmToken = props.extraData.fcmToken;
const user = props.extraData.user;
const account = props.extraData.account;
const salesRep = account.salesRep;
const [salesRepExpanded, setSalesRepExpanded] = useState(false);
const [supportExpanded, setSupportExpanded] = useState(false);
const userRef = Firestore.collection('users').doc(uid)
    const emailSR = () => {
 recordSalesContactEvent("Email");
 return Linking.openURL('mailto:' + salesRep.sr_email);
 }

 const callSR = () => {
 recordSalesContactEvent("Phone");
 return Linking.openURL('tel:' + salesRep.sr_phone)
 }

 const textSR = () => {
 recordSalesContactEvent("Text");
 return Linking.openURL('sms:' + salesRep.sr_phone)
 }

 const callSupport = () => {
 return Linking.openURL('tel:15854922780');
 }

 const emailSupport = () => {
 return Linking.openURL('mailto:info@empiredistributing.net?subject=Empire Distributing App Support');
 }


 function recordSalesContactEvent(method) {
 return analytics.logEvent('Contact_SalesRep', {
 screen: 'Settings',
 purpose: 'Contact Sales Rep',
 contactType: method,
 contactName: salesRep.sr_name,
 });
 }


 const enableTutorial = async () => {
 await TutorialDeviceStorage.setShouldShowTutorial('true');
 navigation.navigate('Tutorial');
 }



const requestSignOut =  async () => {
if (Platform.OS === 'web') {
if (confirm("Sign-Out?") === true) {
signOutUser();
}
}
 else {
 Alert.alert(
 "Sign-Out",
  "You are about to sign out of Empire Distributing, do you wish to proceed?",
   [{
    text: "Proceed",
    onPress: () => signOutUser(),
    style: "default",
    },
    {
    text: "Cancel",
    style: "cancel",
    },],
    {
    cancelable: true,
    }
    );
    }
    };
const signOutUser = () => {
if (fcmToken) {
userRef
.update({
fcmTokens: Firestore.FieldValue.arrayRemove(fcmToken)
}).then(() => {
//sign out
signOut(auth).catch((err) => {
console.error("Error signing user out: ", err);
});
}).catch((err) => {
console.error("Error unsubscribing from notifications: ", err);
});
}
else {
signOut(auth).catch((err) => {
console.error("Error signing user out: ", err);
});
}

}


return (
<SafeAreaView
style={styles.container}
>
<ScrollView
showsVerticalScrollIndicator={false}
>
<View style={styles.headerView}>
<Text style={styles.headerText}>Welcome, {'\n'}<Text style={styles.headerTextBold}>{user.fullName.length > 0? (user.fullName) : ('Guest')}</Text></Text>
<Divider/>
</View>
<View style={styles.sectionHeaderContainer}>
<Text style={styles.sectionHeaderTitle}>Account Information</Text>
</View>
    <ListItem
    containerStyle={styles.listItem}
    bottomDivider={true}>
    <Icon
    name={'account-circle-outline'}
    type={'material-community'}
    size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Account Name</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>{account.accountName}</Text>
        </View>
      </ListItem.Content>
    </ListItem>
    <ListItem
    containerStyle={styles.listItem}
    bottomDivider={true}>
    <Icon
    name={'pound'}
    type={'material-community'}
    size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Account Number</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>{account.id}</Text>
        </View>
      </ListItem.Content>
    </ListItem>
    <ListItem.Accordion
    containerStyle={styles.listItem}
    bottomDivider={true}
    content={
    <>
     <Icon
     style={{marginRight: 15}}
     name={'account-tie-outline'}
     type={'material-community'}
     size={30}
     />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Sales Rep</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>{salesRep.sr_name}</Text>
        </View>
      </ListItem.Content>
    </>
    }
    isExpanded={salesRepExpanded}
    onPress={() => {setSalesRepExpanded(!salesRepExpanded)}}
    >
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {callSR()}}
    bottomDivider={true}
    >
    <Icon name="phone-outline" size={30} type={'material-community'} color={'green'} />
    <ListItem.Content>
    <ListItem.Title><Text style={styles.titleText}>Call</Text></ListItem.Title>
    </ListItem.Content>
    <ListItem.Subtitle>{salesRep.sr_phone}</ListItem.Subtitle>
    </ListItem>
        <ListItem
        containerStyle={styles.listItem}
        onPress={() => {textSR()}}
        bottomDivider={true}
        >
        <Icon name="message-outline" type={'material-community'} size={30} color={'blue'} />
        <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Text</Text></ListItem.Title>
        </ListItem.Content>
        <ListItem.Subtitle>{salesRep.sr_phone}</ListItem.Subtitle>
        </ListItem>
         <ListItem
         containerStyle={styles.listItem}
         onPress={() => {emailSR()}}
         bottomDivider={true}
         >
         <Icon name="email-outline" size={30} type={'material-community'} color={'orange'} />
         <ListItem.Content>
         <ListItem.Title><Text style={styles.titleText}>Email</Text></ListItem.Title>
         </ListItem.Content>
         <ListItem.Subtitle>{salesRep.sr_email}</ListItem.Subtitle>
         </ListItem>
    </ListItem.Accordion>
    <View style={styles.sectionHeaderContainer}>
    <Text style={styles.sectionHeaderTitle}>Profile Preferences</Text>
    </View>
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {navigation.navigate('Preferences', {key: 'displayName'})}}
    bottomDivider={true}>
    <Icon
     name={'person-outline'}
     type={'material'}
     size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Display Name</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>{user.fullName}</Text>
        </View>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
       />
    </ListItem>
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {navigation.navigate('Preferences', {key: 'emailAddress'})}}
    bottomDivider={true}>
    <Icon
     name={'email-outline'}
     type={'material-community'}
     size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Email Address</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>{user.email}</Text>
        </View>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
       />
    </ListItem>
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {navigation.navigate('Preferences', {key: 'password'})}}
    bottomDivider={true}>
    <Icon
     name={'lock-outline'}
     type={'material-community'}
     size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Update Password</Text></ListItem.Title>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
       />
    </ListItem>
        <ListItem
        containerStyle={styles.listItem}
        onPress={() => {navigation.navigate('Preferences', {key: 'deleteUser'})}}
        bottomDivider={true}>
        <Icon
         name={"delete-outline"}
         type={'material-community'}
         size={30}
         />
          <ListItem.Content>
            <ListItem.Title><Text style={{color: 'red'}}>Delete User Data</Text></ListItem.Title>
          </ListItem.Content>
          <ListItem.Chevron
           size={30}
           />
        </ListItem>
    <View style={styles.sectionHeaderContainer}>
    <Text style={styles.sectionHeaderTitle}>App Settings</Text>
    </View>
    <ListItem
     containerStyle={styles.listItem}
     onPress={() => {navigation.navigate('Notifications')}}
     bottomDivider={true}>
     <Icon
      name={'bell-outline'}
      type={'material-community'}
      size={30}
      />
      <ListItem.Content>
      <ListItem.Title>Notifications</ListItem.Title>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
      />
     </ListItem>
    <ListItem
     containerStyle={styles.listItem}
     onPress={() => {Linking.openSettings()}}
     bottomDivider={true}>
     <Icon
      name={'cog-outline'}
      type={'material-community'}
      size={30}
      />
      <ListItem.Content>
      <ListItem.Title>Settings</ListItem.Title>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
      />
     </ListItem>
    <View style={styles.sectionHeaderContainer}>
    <Text style={styles.sectionHeaderTitle}>App Information</Text>
    </View>
    {Platform.OS !== 'web' &&
    <ListItem
     containerStyle={styles.listItem}
     onPress={() => {enableTutorial()}}
     bottomDivider={true}>
     <Icon
      name={'human-greeting'}
      type={'material-community'}
      size={30}
      />
      <ListItem.Content>
      <ListItem.Title>View Tutorial</ListItem.Title>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
      />
     </ListItem>
    }
    <ListItem.Accordion
    containerStyle={styles.listItem}
    bottomDivider={true}
    content={
    <>
     <Icon
     style={{marginRight: 15}}
     name={'lifebuoy'}
     type={'material-community'}
     size={30}
     />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Support</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>Contact Support</Text>
        </View>
      </ListItem.Content>
    </>
    }
    isExpanded={supportExpanded}
    onPress={() => {setSupportExpanded(!supportExpanded)}}
    >
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {callSupport()}}
    bottomDivider={true}
    >
    <Icon name="phone-outline" size={30} type={'material-community'} color={'green'} />
    <ListItem.Content>
    <ListItem.Title><Text style={styles.titleText}>Call</Text></ListItem.Title>
    </ListItem.Content>
    <ListItem.Subtitle>(585) 492-2780</ListItem.Subtitle>
    </ListItem>
    <ListItem
         containerStyle={styles.listItem}
         onPress={() => {emailSupport()}}
         bottomDivider={true}
         >
         <Icon name="email-outline" type={'material-community'} size={30} color={'orange'} />
         <ListItem.Content>
         <ListItem.Title><Text style={styles.titleText}>Email</Text></ListItem.Title>
         </ListItem.Content>
         <ListItem.Subtitle>info@empiredistributing.net</ListItem.Subtitle>
         </ListItem>
    </ListItem.Accordion>
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {navigation.navigate('Preferences', {key: 'legal'})}}
    bottomDivider={true}>
    <Icon
    name={'file-document-outline'}
    type={'material-community'}
    size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Legal</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>Legal Documents</Text>
        </View>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
       />
    </ListItem>
    <ListItem
        containerStyle={styles.listItem}
        onPress={async () => {await OTAUpdates.checkForUpdates();}}
        bottomDivider={true}>
        <Icon
        name={'info-outline'}
        size={30}
        />
          <ListItem.Content>
            <ListItem.Title><Text style={styles.titleText}>Application Version</Text></ListItem.Title>
            <View style={styles.subtitleView}>
              <Text style={styles.subtitleText}>{APPLICATION_VERSION}</Text>
            </View>
          </ListItem.Content>
          <ListItem.Chevron
           size={30}
           />
        </ListItem>
    <ListItem
    containerStyle={styles.listItem}
    bottomDivider={true}>
    <Icon
    name={'copyright'}
    size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Copyright</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>&copy; {COPYRIGHT_YEAR} Empire Distributing | All Rights Reserved</Text>
        </View>
      </ListItem.Content>
    </ListItem>
    <Button
     title="Sign-Out"
     onPress={() => {requestSignOut()}}
     containerStyle={styles.buttonContainer}
     buttonStyle={styles.buttonStyle}
     />
    </ScrollView>
</SafeAreaView>
)
}